import { api } from "../../lib";

export interface MacroRequest {
  id: string;
  requestedById: string;
  code: string;
  diagnosisDescription: string | null;
  microscopicDescription: string | null;
  categoryId: string | null;
  cptId: string | null;
  icdId: string | null;
  status: "pending" | "approved" | "rejected";
  reviewedById: string | null;
  reviewedAt: string | null;
  reviewNotes: string | null;
  createdAt: string;
  updatedAt: string;
  requestedBy?: { id: string; fullName: string } | null;
  reviewedBy?: { id: string; fullName: string } | null;
  category?: { id: string; name: string } | null;
  cptCode?: { id: string; code: string; description: string } | null;
  icdCode?: { id: string; code: string; description: string } | null;
}

export interface CreateMacroRequestInput {
  code: string;
  diagnosisDescription?: string;
  microscopicDescription?: string;
  categoryId?: string;
  cptId?: string;
  icdId?: string;
}

export const macroRequestsService = {
  create: async (input: CreateMacroRequestInput) => {
    return api.post<MacroRequest>("/admin/macro-requests", input);
  },

  getPending: async () => {
    return api.get<MacroRequest[]>("/admin/macro-requests/pending");
  },

  getMine: async () => {
    return api.get<MacroRequest[]>("/admin/macro-requests/mine");
  },

  approve: async (id: string, notes?: string) => {
    return api.post<MacroRequest>(`/admin/macro-requests/${id}/approve`, {
      notes,
    });
  },

  reject: async (id: string, notes: string) => {
    return api.post<MacroRequest>(`/admin/macro-requests/${id}/reject`, {
      notes,
    });
  },
};
